import { useEffect } from 'react';
import { useShopifyCartStore } from '@/stores/shopifyCartStore';

export function useCartSync() {
  const syncCart = useShopifyCartStore(state => state.syncCart);

  useEffect(() => {
    // Sync on initial page load (handles browser refresh after checkout)
    syncCart();
    
    // Sync when user returns to the tab (handles return from checkout in new tab)
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        syncCart();
      }
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [syncCart]);
}
